import { useEffect, useState, useCallback } from 'react'
import ApiPlayers from '../api/ApiPlayers'
import ApiLeagues from '../api/ApiLeagues'

export default function useRegistrationData() {
  const [primaryPlayer, setPrimaryPlayer] = useState(null)
  const [leagues, setLeagues] = useState([])
  const [myLeagues, setMyLeagues] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const loadData = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const allPlayers = await ApiPlayers.getMyPlayers()
      const primary = allPlayers.find((p) => p.primary_player) || null
      setPrimaryPlayer(primary)

      const [allLeagues, myCurrentLeagues] = await Promise.all([
        ApiLeagues.getAll(),
        ApiLeagues.getMyLeagues(),
      ])

      const allLeaguesTransformed = allLeagues
        .filter((league) => league.league_status === 'registration_open')
        .map((league) => ({
          ...league,
          id: parseInt(league.id, 10),
        }))
      const myLeagueIds = myCurrentLeagues.map((league) =>
        parseInt(league.league_id, 10),
      )
      setLeagues(allLeaguesTransformed)
      setMyLeagues(myLeagueIds)
    } catch (err) {
      setError(err.message || 'Failed to load registration data.')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadData()
  }, [loadData])

  return {
    primaryPlayer,
    leagues,
    myLeagues,
    setMyLeagues,
    loading,
    error,
    loadData,
  }
}
